import React, { useState } from 'react';
import '../FollowUps/CustomSelect.css'; // Import the CSS file for styling

const CustomSelect = ({ options, defaultSelected, onSelect }) => {

    const [selectedOption, setSelectedOption] = useState(defaultSelected);
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
        onSelect(option)
    };

    return (
        <div className={`custom-select club-select ${isOpen ? 'open' : ''}`}>
            <div className="selected-option-drop" onClick={toggleDropdown}>
                <span className="selected-option-text">{selectedOption?.label}</span>
                <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                    <i className="bi bi-chevron-down" />
                </span>
            </div>
            {isOpen && (
                <div className="options-list custom-options-list club-options-list">
                    {options.map(option => (
                        <div
                            key={option.value}
                            className={`option custom-option ${selectedOption?.value === option.value ? 'selected' : ''}`}
                            onClick={() => handleOptionSelect(option)}
                        >
                            <span className="option-label">{option?.label}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
